
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { faRotate } from '@fortawesome/free-solid-svg-icons';
import { Observable, Subject, filter, catchError, of, switchMap, takeUntil, tap } from 'rxjs';
import { AccountService } from 'src/app/shared/services/account.service';
import { DataService } from 'src/app/shared/services/data.service';
import { Trade } from '../models/trade';
import _ from 'lodash';
import { TradeSummary } from '../models/trade-summary';
import { DialogInputConfig, DialogResult } from 'src/app/shared/models/dialog-input';
import { DialogInputComponent } from 'src/app/shared/components/dialog-input/dialog-input.component';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { TableColumn, TableColumnType } from '../models/allocation-table';

@Component({
    selector: 'app-allocation-list',
    templateUrl: './allocation-list.component.html',
    styleUrl: './allocation-list.component.scss',
    standalone: false
})
export class AllocationListComponent implements OnInit, OnDestroy {
    faRotate: any = faRotate;

    public displayedColumns: string[] = ['accountId', 'userNamed', 'symbol', 'side', 'avgPrice', 'totalQuantity', 'totalValue', 'priceCalc', 'quantityCalc'];
    allocationColumns: TableColumn[] = [
        {key: 'accountId', displayName: 'Account', type: TableColumnType.text, isDisplayed: true, isFilterEnabled: true, isBoldText: false},
        {key: 'userNamed', displayName: 'User', type: TableColumnType.text, isDisplayed: true, isFilterEnabled: true, isBoldText: false},
        {key: 'orderId', displayName: 'Order ID', type: TableColumnType.text, isDisplayed: false, isFilterEnabled: true, isBoldText: false},
        {key: 'symbol', displayName: 'Symbol', type: TableColumnType.text, isDisplayed: true, isFilterEnabled: true, isBoldText: false},
        {key: 'accountPk', displayName: 'Account PK', type: TableColumnType.text, isDisplayed: false, isFilterEnabled: true, isBoldText: false},
        {key: 'side', displayName: 'Side', type: TableColumnType.text, isDisplayed: true, isFilterEnabled: true, isBoldText: false},
        {key: 'avgPrice', displayName: 'Avg Price', type: TableColumnType.currency, isDisplayed: true, isFilterEnabled: true, isBoldText: false},
        {key: 'totalQuantity', displayName: 'Quantity', type: TableColumnType.number, isDisplayed: true, isFilterEnabled: true, isBoldText: false},
        {key: 'totalValue', displayName: 'Value', type: TableColumnType.currency, isDisplayed: true, isFilterEnabled: true, isBoldText: false},
        {key: 'priceCalc', displayName: 'Price to Allocate', type: TableColumnType.currency, isDisplayed: true, isFilterEnabled: false, isBoldText: true},
        {key: 'quantityCalc', displayName: 'Qty to Allocate', type: TableColumnType.number, isDisplayed: true, isFilterEnabled: false, isBoldText: true},
    ];

    public allElements: Trade[] = [];
    public pagedElements$: Observable<Trade[]>;

    public pageIndex: number = 0;
    public pageSize: number = 25;

    public loading: boolean = true;
    private onDestroy$ = new Subject<void>();

    constructor(
        private accountService: AccountService,
        private router: Router,
        private data: DataService,
        public dialog: DialogService
    ) { }

    ngOnInit(): void {
        this.loadData();
    }

    public allocateSelected(element: Trade) {
        this.data.allocationDetail(element);
        this.router.navigate(["/allocate/allocation-detail"]);
    }

    public loadData(): void {
        this.loading = true;
        this.data.currentRiaId$
            .pipe(
                filter(riaId => riaId > 0), // Ensure riaId is valid
                switchMap(riaId => this.accountService.getAllTrade(riaId)),
                catchError(error => this.handleFetchError(error)),
                tap(() => this.loading = false),
                takeUntil(this.onDestroy$)
            )
            .subscribe((elements: Trade[])  => {
                const parentsChecked = false;

                elements.forEach(element => {
                    //element.accountId = element.accountId;
                    //element.user = element.userNamed;
                    //element.avgPrice = element.avgPrice;
                   // element.totalQuantity = element.totalQuantity;
                    //element.totalValue = element.totalValue;
                    element.quantityCalc = 0;
                    element.priceCalc = 0;
                    element.ordersChecked = 0;
                    element.expanded = false;
                    element.parentChecked = parentsChecked;
                    element.orders.forEach((order) => {

                        order.parent = element;
                        //order.accountId = order.accountId;
                        //order.orderNumber = order.orderId;
                        order.quantityAllocated = order.allcQuantity || 0;
                        order.quantity = order.execQuantity;
                        order.quantityToAllocate = order.quantity - order.quantityAllocated;
                        order.totalQuantity = order.execQuantity;

                        element.quantity += order.quantity;
                        element.value += order.execPrice * order.quantity;

                        if (element.parentChecked) {
                            order.checked = element.parentChecked;

                            element.quantityCalc += order.quantity;
                            element.priceCalc += order.execPrice * order.quantity;
                            element.ordersChecked++;
                        }
                    });
                });

                this.allElements = elements;
            });
    }

    private handleFetchError(error: any) {
        console.error("Error fetching data:", error);
        return of([]);
    }

    ngOnDestroy(): void {
        this.onDestroy$.next();
        this.onDestroy$.complete();
    }
}